import { jsx } from "react/jsx-runtime";
import AlertTriangle from "@crehana/compass.icons.outline/AlertTriangle";
import CheckmarkCircle from "@crehana/compass.icons.outline/CheckmarkCircle";
import Edit2 from "@crehana/compass.icons.outline/Edit2";
import Email from "@crehana/compass.icons.outline/Email";
import Exit from "@crehana/compass.icons.outline/Exit";
import Flag2 from "@crehana/compass.icons.outline/Flag2";
import Star from "@crehana/compass.icons.outline/Star";
import Trash2 from "@crehana/compass.icons.outline/Trash2";
import { cn } from "../utils.js";
const icons = {
    default: {
        Icon: Flag2,
        colorClassName: 'tw-text-primary-light-100',
        bgClassName: 'tw-bg-primary-light-300',
        borderClassName: 'tw-border-primary-light-200',
        sizes: {
            s: 20,
            m: 28
        }
    },
    success: {
        Icon: CheckmarkCircle,
        colorClassName: 'tw-text-success-500',
        bgClassName: 'tw-bg-success-300',
        borderClassName: 'tw-border-success-100',
        sizes: {
            s: 20,
            m: 28
        }
    },
    warning: {
        Icon: AlertTriangle,
        colorClassName: 'tw-text-warning-600',
        bgClassName: 'tw-bg-warning-300',
        borderClassName: 'tw-border-warning-100',
        sizes: {
            s: 20,
            m: 26
        }
    },
    alert: {
        Icon: Trash2,
        colorClassName: 'tw-text-alert-500',
        bgClassName: 'tw-bg-alert-200',
        borderClassName: 'tw-border-alert-100',
        sizes: {
            s: 20,
            m: 28
        }
    },
    exit: {
        Icon: Exit,
        colorClassName: 'tw-text-neutral-light-700',
        bgClassName: 'tw-bg-neutral-light-400',
        borderClassName: 'tw-border-neutral-light-300',
        sizes: {
            s: 20,
            m: 28
        }
    },
    info: {
        Icon: Email,
        colorClassName: 'tw-text-info-500',
        bgClassName: 'tw-bg-info-200',
        borderClassName: 'tw-border-info-100',
        sizes: {
            s: 20,
            m: 28
        }
    },
    reward: {
        Icon: Star,
        colorClassName: 'tw-text-neutral-light-100',
        bgClassName: 'tw-bg-primary-light-300',
        borderClassName: 'tw-border-primary-light-200',
        sizes: {
            s: 20,
            m: 28
        }
    },
    edit: {
        Icon: Edit2,
        colorClassName: 'tw-text-neutral-light-100',
        bgClassName: 'tw-bg-primary-light-300',
        borderClassName: 'tw-border-primary-light-200',
        sizes: {
            s: 20,
            m: 28
        }
    }
};
const DialogIcon = ({ variant, size, Icon: IconProp, className })=>{
    const { Icon: IconFromObj, sizes, colorClassName, bgClassName, borderClassName } = icons[variant];
    const Icon = IconProp || IconFromObj;
    return /*#__PURE__*/ jsx("span", {
        className: cn('tw-flex tw-items-center tw-justify-center tw-border-solid  tw-rounded-full tw-mx-auto', bgClassName, borderClassName, {
            'tw-w-5.6 tw-h-5.6': 'm' === size,
            'tw-border-0.8': 'm' === size,
            'tw-w-4 tw-h-4': 's' === size,
            'tw-border-0.4': 's' === size
        }, className),
        children: /*#__PURE__*/ jsx(Icon, {
            size: sizes[size],
            className: colorClassName
        })
    });
};
const Dialog_DialogIcon = DialogIcon;
export default Dialog_DialogIcon;
export { DialogIcon };
